// Path: ./src/app/components/UploadMenuModal/index.tsx
import * as React from "react";
import { MultipleSelect } from "../MultiSelectDropDown";
import {
  Card,
  BottomSection,
  Button,
  ButtonWrapper,
  LeftSideWrapper,
  SyncUpdateHeader,
  RightSideWrapper,
  RightSideTitle,
  InheritTextInputField,
  DotDotDivider,
  UnitWrapper,
  SubmitButton,
  LocalButton,
  DateWrapper,
  TopSection,
  LeftSideTitle,
  SmallImageWrapper,
  FlyerImageContainer,
  RankWrapper,
  RankTitle,
  RankInputField,
} from "./styled";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";
import { DatePickerMui } from "../DatePickerMui";
import { SmallDealImgCard } from "../SmallDealImgCard";
import {
  AutocompleteOption,
  CustomAutocompleteMultiSelect,
} from "../CustomAutocomplete";
import {
  GfImage,
  GfMerchantDto,
  GfStoreDto,
  GfMerchant,
  GfMenuTag,
  GfStore,
} from "@swagger/typescript-fetch-goflyer";
import { CircularProgress } from "@mui/material";
import CustomModal from "../CustomModal";
import { disableWheelOnInput } from "../../../utils/disableWheelOnInput";
import ImageDropZone from "../../../components/ImageDropZone";

interface Props {
  /**
   * Callback function for closing a creation modal.
   * Invoked when the modal is closed, typically by clicking a close button or overlay.
   */
  onClose?: () => void;
  Name?: string;

  // eslint-disable-next-line
  handleName?: (value?: React.ChangeEvent<HTMLInputElement>) => void;

  // eslint-disable-next-line

  salePrice?: string;

  // eslint-disable-next-line

  regularPrice?: string;

  // eslint-disable-next-line

  priceRemarks?: string;

  store?: {
    label: string;
    value: GfStoreDto;
  }[];
  // eslint-disable-next-line
  handleStore?: (value?: GfStore[]) => void;
  storeOptionList?: {
    label: string;
    value: GfStoreDto;
  }[];

  menuTag?: GfMenuTag[];
  // eslint-disable-next-line
  handleMenuTag?: (value?: GfMenuTag[]) => void;
  menuTagOptionList?: AutocompleteOption<GfMenuTag>[];

  merchant?: AutocompleteOption<GfMerchant>[];
  // eslint-disable-next-line
  handleMerchant?: (value?: GfMerchantDto[]) => void;
  merchantOptionList?: {
    label: string;
    value: GfMerchantDto;
  }[];

  imageSrc?: string;
  // eslint-disable-next-line
  handleLocalUpload?: (event: React.ChangeEvent<HTMLInputElement>) => void; //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) need to fix this any data type
  isUploadingImage?: boolean;
  //

  imageText?: string;
  /**
   * Callback function for submitting a form to create or edit a menu/menu.
   * Invoked when the form is submitted to save changes or create a new menu/menu.
   */
  onSubmit?: () => void;
  flyerImages?: GfImage[];
  localFiles?: File[];
  startDate?: Date;
  endDate?: Date;
  // eslint-disable-next-line
  handleStartDate?: (value: Date) => void;
  // eslint-disable-next-line
  handleEndDate?: (value: Date) => void;
  // eslint-disable-next-line
  handleMenuCancelButton?: (id: string) => void;
  isLocalImageSelect?: "local" | "select" | undefined;
  isEditing?: boolean;
  // eslint-disable-next-line
  handleRank?: (value?: React.ChangeEvent<HTMLInputElement>) => void;
  rankValue?: number;
  showDateRange?: boolean;
  flyerTagTitle?: string;
  showSelectImageButton?: boolean;
  isOptionLoading?: boolean;
  DropImageHereTitle?: string;
  handleOnStoreSearch?: (value: string) => void;
  handleOnMerchantSearch?: (value: string) => void;
  isOptionLoadingMerchant?: boolean;
  getDropZoneProps?: (
    overrides?: React.HTMLAttributes<HTMLElement>
  ) => React.HTMLAttributes<HTMLElement>;
  isDragging?: boolean;
  showReorderModal?: boolean;
  pendingDropFiles?: File[];
  handleReorderConfirm?: (orderedFiles: File[]) => void;
  handleReorderCancel?: () => void;
}
export const UploadMenuModal = ({
  onClose,
  Name,
  handleName,
  handleLocalUpload,
  isUploadingImage,
  flyerImages,
  localFiles,
  onSubmit,
  store,
  storeOptionList,
  menuTag,
  menuTagOptionList,
  handleMenuTag,
  startDate,
  endDate,
  handleEndDate,
  handleStartDate,
  handleMenuCancelButton,
  isLocalImageSelect,
  merchant,
  handleMerchant,
  merchantOptionList,
  handleStore,
  isEditing,
  handleRank,
  rankValue,
  showDateRange = true,
  flyerTagTitle,
  showSelectImageButton,
  DropImageHereTitle,
  handleOnStoreSearch,
  handleOnMerchantSearch,
  isOptionLoading,
  isOptionLoadingMerchant,
  getDropZoneProps,
  isDragging,
  showReorderModal,
  pendingDropFiles,
  handleReorderConfirm,
  handleReorderCancel,
}: Props) => {
  const { t } = useTranslation();

  return (
    <CustomModal onClose={onClose} dataTestId="upload-menu-modal">
      <Card>
        <LeftSideWrapper>
          <TopSection>
            <LeftSideTitle>{t(messages.Name())}</LeftSideTitle>
            <InheritTextInputField
              placeholder={t(messages.Name()) as string}
              onChange={handleName}
              value={Name}
              data-testid={`first-name-input`}
            ></InheritTextInputField>

            <CustomAutocompleteMultiSelect
              title={`${t(messages.Merchant())}`}
              isLoading={isOptionLoadingMerchant}
              selectedValues={merchant}
              handleOnChange={handleMerchant}
              optionsList={merchantOptionList}
              handleOnSearch={handleOnMerchantSearch}
              multiSelect={false}
              WrapperCss={`
                  margin-left:10px;
                  margin-top:10px;
                `}
              inputCss={`
                max-width: 400px;
                `}
              dataTestId={`merchant-select`}
            ></CustomAutocompleteMultiSelect>

            {merchant?.length ? (
              <></>
            ) : (
              <CustomAutocompleteMultiSelect
                title={t(messages.Stores()) as string}
                optionsList={storeOptionList}
                isLoading={isOptionLoading}
                selectedValues={store}
                multiSelect={true}
                handleOnChange={handleStore}
                handleOnSearch={handleOnStoreSearch}
                WrapperCss={`
                  margin-left:10px;
                  margin-top:10px;
                `}
                inputCss={`
                max-width: 400px;
                `}
                dataTestId={`store-select`}
              />
            )}
          </TopSection>
          <DotDotDivider></DotDotDivider>

          <UnitWrapper>
            <MultipleSelect
              title={
                flyerTagTitle ? flyerTagTitle : `${t(messages.Menu_Tag())}`
              }
              FormControlStyle={{
                width: 300,
              }}
              selectedValue={menuTag}
              onSelect={handleMenuTag}
              selectOptions={menuTagOptionList}
              wrapperStyle={`
                  flex-direction: row;
                  align-items: center;
                  justify-content: space-between;
                  @media (max-width: 649px) {
                    flex-direction: column;
                    align-items: start;
                    justify-content: start;
                  }
                  `}
              dataTestId={`menuTag-select`}
            ></MultipleSelect>
            <RankWrapper>
              <RankTitle>{t(messages.Rank())}</RankTitle>
              <RankInputField
                placeholder={t(messages.Rank()) as string}
                onChange={handleRank}
                value={rankValue}
                type="number"
                onWheel={disableWheelOnInput}
                data-testid={`rank-input`}
              ></RankInputField>
            </RankWrapper>
          </UnitWrapper>
          {showDateRange ? (
            <DateWrapper>
              <DatePickerMui
                onChange={handleStartDate}
                text={`${t(messages.Start_Date())}`}
                textCss="
                font-size: 16px;
                margin-left:8px;

                "
                defaultDate={startDate}
                dateInputPadding={5}
                dataTestId={`start-date`}
              ></DatePickerMui>
              <DatePickerMui
                minDate={
                  // startDate ? dayjs(startDate).add(1, "day") : undefined
                  startDate
                }
                onChange={handleEndDate}
                text={`${t(messages.End_Date())}`}
                textCss="
                font-size: 16px;
                margin-left:8px;
                "
                defaultDate={endDate}
                dateInputPadding={5}
                dataTestId={`end-date`}
              ></DatePickerMui>
            </DateWrapper>
          ) : (
            <></>
          )}

          <BottomSection>
            <SyncUpdateHeader>{t(messages.Sync_Update_to())}:</SyncUpdateHeader>
            {/* <CheckBoxWrapper>
                <CheckBoxMui title="My Website & App" />
                <CheckBoxMui title="Goflyer & App" />
              </CheckBoxWrapper> */}
          </BottomSection>
        </LeftSideWrapper>
        <RightSideWrapper>
          <RightSideTitle>
            {DropImageHereTitle
              ? DropImageHereTitle
              : `${t(messages.Select_Flyer_or_Drop_Flyer_Here())}`}
          </RightSideTitle>
          <ImageDropZone
            uploader={{ getDropZoneProps, isDragging, showReorderModal, pendingDropFiles, handleReorderConfirm, handleReorderCancel }}
            label={t(messages.Drag_your_image_here())}
            overlayContent={t(messages.Drag_your_image_here())}
            style={{ position: "relative", width: "100%" }}
            data-testid="drag-drop-zone"
          >
            <FlyerImageContainer>
              {flyerImages?.length ? (
                <>
                  {flyerImages?.map(
                    (value: GfImage, index: string | number) => {
                      return (
                        <SmallImageWrapper
                          key={index}
                          data-testid="uploadmenumodal-test-id"
                        >
                          <SmallDealImgCard
                            imageSrc={value.src}
                            cancelButtonClick={() => {
                              handleMenuCancelButton &&
                                handleMenuCancelButton(value.id);
                            }}
                          />
                        </SmallImageWrapper>
                      );
                    }
                  )}
                  {localFiles?.map((value: File, index: string | number) => {
                    return (
                      <SmallImageWrapper
                        key={index}
                        data-testid="uploadmenumodal-test-id"
                      >
                        <SmallDealImgCard
                          imageSrc={URL.createObjectURL(value)}
                          cancelButtonClick={() => {
                            handleMenuCancelButton &&
                              handleMenuCancelButton(value.name);
                          }}
                        />
                      </SmallImageWrapper>
                    );
                  })}
                </>
              ) : (
                <></>
              )}
            </FlyerImageContainer>
            {isUploadingImage && <CircularProgress sx={{ color: "#ff813a" }} />}
            <ButtonWrapper>
              {isLocalImageSelect === "local" ? (
                <>
                  <input
                    type="file"
                    id="upload"
                    accept="image/*"
                    hidden
                    multiple
                    onChange={handleLocalUpload}
                    data-testid={`image-local-upload`}
                  />
                  <LocalButton htmlFor="upload">
                    {t(messages.Local_Upload())}
                  </LocalButton>
                </>
              ) : (
                <></>
              )}
              {isLocalImageSelect === "select" ? (
                <Button>{`${t(messages.Select_Image())}`}</Button>
              ) : (
                <></>
              )}
              {isLocalImageSelect === undefined ? (
                <>
                  {showSelectImageButton ? (
                    <Button>{`${t(messages.Select_Image())}`}</Button>
                  ) : (
                    <></>
                  )}
                  <input
                    type="file"
                    id="upload"
                    accept="image/*"
                    hidden
                    multiple
                    onChange={handleLocalUpload}
                    data-testid={`image-local-upload`}
                  />
                  <LocalButton htmlFor="upload">
                    {t(messages.Local_Upload())}
                  </LocalButton>
                </>
              ) : (
                <></>
              )}
            </ButtonWrapper>
          </ImageDropZone>

          <SubmitButton onClick={onSubmit} data-testid={`submit-button`}>
            {isEditing ? t(messages.Update()) : t(messages.Save())}
          </SubmitButton>
        </RightSideWrapper>
      </Card>
    </CustomModal>
  );
};
